import ManagementLayout from '@/layout/Management'
import { Role } from './roles'

export default [{
  path: '/zarzadca',
  component: ManagementLayout,
  meta: {
    auth: true
  },
  children: [
    {
      path: '',
      component: () => import('@/components/portals/index'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    // dashboard
    {
      path: 'podsumowanie',
      component: () => import('@/components/dashboard/Management'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'filmy',
      component: () => import('@/components/videos/List'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'filmy/nowy',
      component: () => import('@/components/videos/EditVideo'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },    
    {
      path: 'filmy/:id',
      component: () => import('@/components/videos/EditVideo'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },     
    {
      path: 'galerie',
      component: () => import('@/components/galleries/List'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'galerie/dodaj',
      component: () => import('@/components/galleries/Manage'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },    
    {
      path: 'galerie/:id',
      component: () => import('@/components/galleries/Manage'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },       
    // grupy uzytkownikow
    {
      path: 'uzytkownicy/grupy',
      component: () => import('@/components/users/admin/GroupsList'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin]
      }
    },
    {
      path: 'uzytkownicy/grupy/nowa',
      component: () => import('@/components/users/admin/GroupAdd'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin]
      }
    },      
    {
      path: 'uzytkownicy/grupy/:id',
      component: () => import('@/components/users/admin/GroupEdit'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin]
      }
    },               
    // uzytkownicy
    {
      path: 'uzytkownicy/admin',
      component: () => import('@/components/users/admin/List'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin]
      }
    },
    {
      path: 'uzytkownicy/admin/nowy',
      component: () => import('@/components/users/admin/New'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin]
      }
    },
    {
      path: 'uzytkownicy/admin/:id',
      component: () => import('@/components/users/admin/Edit'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin]
      }
    },
    {
      path: 'uzytkownicy/portal',
      component: () => import('@/components/users/portal/List'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'uzytkownicy/portal/nowy',
      component: () => import('@/components/users/portal/New'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'uzytkownicy/portal/:id',
      component: () => import('@/components/users/portal/Edit'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    // statystyki
    {
      path: 'statystyki',
      component: () => import('@/components/statistics/Index'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'artlist',
      props: { basePath: '/zarzadca' },
      component: () => import('@/components/statistics/Articles'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },    
    {
      path: 'cele',
      props: { basePath: '/zarzadca' },
      component: () => import('@/components/statistics/Targets'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'cele/zarzadzaj/:id',
      props: { basePath: '/zarzadca' },
      component: () => import('@/components/statistics/Manage'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'cele/zarzadzaj/:id/:targetId',
      props: { basePath: '/zarzadca' },
      component: () => import('@/components/statistics/Manage'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'cele/autor/:id',
      props: { basePath: '/zarzadca' },
      component: () => import('@/components/statistics/UserTargets'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },       
    // portale
    {
      path: 'portale',
      component: () => import('@/components/portals/index'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    // adsy
    {
      path: 'reklamy/kampanie',
      component: () => import('@/components/ads/List'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'reklamy/kampanie/nowa',
      component: () => import('@/components/ads/New'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'reklamy/kampanie/:customerId/:uniqueId',
      component: () => import('@/components/ads/Edit'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    // klienci
    {
      path: 'klienci',
      component: () => import('@/components/clients/List'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'klienci/nowy',
      component: () => import('@/components/clients/New'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'klienci/:id',
      component: () => import('@/components/clients/Edit'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },    
    // ogłoszenia
    {
      path: 'ogloszenia',
      component: () => import('@/components/classifieds/List'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'ogloszenia/kategorie',
      component: () => import('@/components/classifieds/categories/List'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'ogloszenia/kategorie/nowa',
      component: () => import('@/components/classifieds/categories/New'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'ogloszenia/kategorie/:id',
      component: () => import('@/components/classifieds/categories/Edit'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'ogloszenia/:id',
      component: () => import('@/components/classifieds/Edit'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },    
    // tagi
    {
      path: 'tagi',
      component: () => import('@/components/tags/List'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },    
    {
      path: 'tagi/:id',
      component: () => import('@/components/tags/Edit'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    // słowa kluczowe
    {
      path: 'skluczowe',
      component: () => import('@/components/keywords/List'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },    
    {
      path: 'skluczowe/nowe',
      component: () => import('@/components/keywords/New'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'skluczowe/:id',
      component: () => import('@/components/keywords/Edit'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    // dodatkowe
    {
      path: 'wersja',
      component: () => import('@/components/dashboard/Version'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'dev/logi',
      component: () => import('@/components/devRoutes/Logs'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin]
      }
    }, 
    {
      path: 'dev/logi/:type/:name',
      component: () => import('@/components/devRoutes/Logs'),
      props: { basePath: '/zarzadca' },
      meta: {
        authorize: [Role.Admin]
      }
    },
    {
      path: 'quizy',
      props: { basePath: '/zarzadca' },
      component: () => import('@/components/quizes/index'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'quizy/dodaj',
      props: { basePath: '/zarzadca' },
      component: () => import('@/components/quizes/Manage'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    {
      path: 'quizy/:id',
      props: { basePath: '/zarzadca' },
      component: () => import('@/components/quizes/Manage'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },
    // plebiscyty i sondy
    {
      path: 'sondy',
      // component: () => import('@/components/plebiscites/List'),
      component: () => import('@/components/polls/List'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    }, 
    {
      path: 'sondy/nowy',
      component: () => import('@/components/polls/Manage'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },         
    {
      path: 'sondy/:id',
      component: () => import('@/components/polls/Manage'),
      meta: {
        authorize: [Role.Admin, Role.Redactor]
      }
    },        
    //linki
    //{
    //  path: 'linki',
    //  component: () => import('@/components/links/List'),
    //  props: { basePath: '/zarzadca' },
    //  meta: {
    //    authorize: [Role.Admin, Role.Redactor]
    //  }
    //},
    //{
    //  path: 'linki/nowy',
    //  component: () => import('@/components/links/New'),
    //  props: { basePath: '/zarzadca' },
    //  meta: {
    //    authorize: [Role.Admin, Role.Redactor]
    //  }
    //},    
    //{
    //  path: 'linki/:id',
    //  component: () => import('@/components/links/Edit'),
    //  props: { basePath: '/zarzadca' },
    //  meta: {
    //    authorize: [Role.Admin, Role.Redactor]
    //  }
    //},  
  ]
}]
